export * from '@fhs/routing/src/routes/(tabs)/rewards/index';
export { default } from '@fhs/routing/src/routes/(tabs)/rewards/index';
